var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sun-editor-editable"},[_c('textarea',{ref:"text-editor"})])
}
var staticRenderFns = []

export { render, staticRenderFns }